

export const VERSION_CONFIG = {
  // BUILD_NO : ,
  RELEASE_NO : '1.0.1',
};

